export default "/images/6d3a00c0f5219ba33e148d98682d457b.avif";